<template>
  <div class="drawer-container">
    <div>
      <h3 class="drawer-title">系统布局配置</h3>

      <div class="drawer-item">
        <span>主题色</span>
        <theme-picker
          style="float: right; margin: -3px 8px 0 0; height: 26px"
          @change="onThemeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ThemePicker from '@/components/theme-picker'

export default {
  components: { ThemePicker },

  methods: {
    onThemeChange(val) {
      // this.$store.dispatch('changeTheme', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.drawer-container {
  padding: 24px;
  font-size: 14px;
  line-height: 1.5;
  word-wrap: break-word;

  .drawer-title {
    margin-bottom: 12px;
    font-size: 14px;
    line-height: 22px;
    color: rgba(0, 0, 0, 0.85);
  }

  .drawer-item {
    padding: 12px 0;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
  }

  .drawer-switch {
    float: right;
  }
}
</style>
